import { useCallback } from "react"
import { saveRegionsFetch } from "store/middlewares/region.crud"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { RegionRM } from "models/RM"
import { audioCuttingSaveDraftFetch } from "store/middlewares/markingWords.crud"
import { markingWordsHooks } from "pages/Admin/TranscriptionSystem/MarkingWords"
import { useParams } from "react-router-dom"
import qc from "keys/queryClient"

const useMarkingAudioSaveDraft = () => {
    const params = useParams()
    const queryClient = useQueryClient()

    let assessmentID = params.assessmentID

    const isTraining = markingWordsHooks.useIsTraining()

    const { mutateAsync: saveRegions, isPending: saveRegionsLoading } = useMutation({
        mutationFn: saveRegionsFetch
    })
    const { mutateAsync: _saveDraft, isPending: saveDraftLoading } = useMutation({
        mutationFn: audioCuttingSaveDraftFetch
    })

    const saveDraft = useCallback(async (regionsList) => {
       
        let nRegions = []
        regionsList.forEach(region => {
            nRegions.push(new RegionRM(region))
        });
        
        await saveRegions({ id: assessmentID, regions: nRegions })
        await _saveDraft({ id: assessmentID, isTrainingAssessment: isTraining })
        
        await queryClient.refetchQueries({
            queryKey: [qc.regions, assessmentID],
            type: 'active',
            exact: true
        })

    }, [assessmentID])

    return {
        action: saveDraft,
        isPending: saveRegionsLoading || saveDraftLoading
    }
}

export default useMarkingAudioSaveDraft